import React from 'react'
function T3sim(){
    return <div>T3sim</div>
}

export default T3sim